'use client';

// ContentCoverageSummary - Display what topics the bot can answer about
// NOTE: Feature disabled - component returns null

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import type { ContentSource } from './types';

export interface ContentCoverageSummaryProps {
  /** Main topics the bot can answer about */
  topics: string[];
  /** Content sources with types */
  sources?: ContentSource[];
  /** Whether data is loading */
  isLoading?: boolean;
}

/**
 * ContentCoverageSummary - Display what topics the bot can answer about
 *
 * NOTE: This feature has been disabled. The component always returns null.
 * Keeping the interface for backwards compatibility.
 */
export function ContentCoverageSummary({
  topics: _topics,
  sources: _sources = [],
  isLoading = false,
}: ContentCoverageSummaryProps) {
  // Feature disabled - return null for both loading and loaded states
  if (isLoading) {
    return null;
  }

  return null;
}

export default ContentCoverageSummary;
